import AddPlugin from "../../../../source/shared/add-plugin.mdx";
import DownloadSchema from "../../../../source/shared/download-schema.mdx";
import * as React from 'react';
export default {
  AddPlugin,
  DownloadSchema,
  React
};